import React from 'react';
import { MODE } from '../../../constants';
import FormsPreviewHeader from '../forms-preview-header';
import PreviewDisabledHeader from '../preview-disabled-header';

type PreviewHeaderProps = {
  type: string;
  isDisabled: boolean;
};

const PreviewHeader = ({ type, isDisabled }: PreviewHeaderProps) => {
  if (type === MODE.FILE_REQUEST && isDisabled) {
    return <PreviewDisabledHeader />;
  }
  if (type === MODE.FORM) {
    return <FormsPreviewHeader />;
  }

  return null;
};

export default PreviewHeader;
